import { Stack, Typography, Container } from '@mui/material'
import ProjectBreadcrumb from '@/components/project-tables/ProjectBreadcrumb'
import { useGetProjectModels } from '@/service-library/hooks/project-models'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'
import { useMemo } from 'react'
import ModelTable, { ModelGroup } from './ModelTable'
import { ProjectModelType } from '@/types/project-models'

export default function ModelsTablePage() {
  const { project } = useProjectContext()

  // Fetch all project models for the current project
  const { projectModels, isPending } = useGetProjectModels({
    filters: {
      limit: '1000',
      project_id: project.id,
      fields__include: 'project_model_type,project_model_versions',
    },
  })

  // Group models by parent-child relationships
  const modelGroups: ModelGroup[] = useMemo(() => {
    if (!projectModels) return []

    const filteredModels = projectModels.filter((model) => {
      const modelType = (model.project_model_type as ProjectModelType).code
      return modelType !== 'OCR' && modelType !== 'AI Agent - OCR Review'
    })

    const parentModels = filteredModels.filter(
      (model) => !model.parent_model_id,
    )

    return parentModels.map((parent) => {
      const children = filteredModels.filter(
        (model) => model.parent_model_id === parent.id,
      )
      return { parentModel: parent, childModels: children }
    })
  }, [projectModels])

  return (
    <Container maxWidth="xl">
      <ProjectBreadcrumb label="Model Tables" />
      <Stack spacing={2} sx={{ mt: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h5">Models</Typography>
        </Stack>

        {isPending && <Typography>Loading models...</Typography>}
        {!isPending && modelGroups.length === 0 && (
          <Typography>No models found for this project.</Typography>
        )}
        {modelGroups.map((group) => (
          <ModelTable key={group.parentModel.id} group={group} />
        ))}
      </Stack>
    </Container>
  )
}
